import { Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Constants } from 'src/app/common';
import { IMenuOption } from 'src/app/models';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { SideBarService } from 'src/app/services/side-bar.service';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faBars, faChevronLeft } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  // session: any;
  sidebarState: boolean;
  menu: IMenuOption[];
  currentPath = 'Inicio';
  @Input() currentUser: any;

  constructor(
    private sidebarService: SideBarService, 
    private authenticationService: AuthenticationService,
    private router: Router,
    library: FaIconLibrary
    ) {
      library.addIcons(faBars, faChevronLeft)
      this.menu = Constants.GetMenu;
      this.sidebarState = true;
      this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
      this.sidebarService.currentPath.subscribe(next => this.currentPath = next);
      this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {});
  }

  ngOnInit(): void { }

  toggleSidebar() {
    this.sidebarState = !this.sidebarState;
    this.sidebarService.toggler.next(this.sidebarState);
  }

  menuMapper(menuOptions: IMenuOption[], target: string): void {
    menuOptions.forEach(x => x.Selected = false);

    menuOptions.forEach(x => {
      if (x.Children.length > 0) {
        x.Children.forEach(y => {
          if (y.Route === ('/' + target)) this.currentPath = y.Name;
        });
      }
      else {
        if (x.Route === ('/' + target)) this.currentPath = x.Name;
      }
    });
  }
}
